import { HttpModel } from '@/Shared/domain'
import type {
  ContactModel,
  FoodTypeModel,
  RestaurantModel,
  StoresRepository,
} from '@/Store/domain'
import { StoreForm, StoreStickersForm } from '@/Store/ui/hooks'

interface IStores {
  getRestaurantData: (merchantTargetId: number) => Promise<HttpModel<RestaurantModel>>
  getRestaurantFoodTypes: () => Promise<HttpModel<FoodTypeModel[]>>
  saveRestaurantData: (data: StoreForm) => Promise<HttpModel<boolean>>
  getStoreContactsData: (merchantTargetId: number) => Promise<HttpModel<ContactModel[]>>
  orderStoreStickers: (data: StoreStickersForm) => Promise<HttpModel<boolean>>
  getKindergartenData: (merchantTargetId: number) => Promise<HttpModel<RestaurantModel>>
  saveKindergartenData: (data: StoreForm) => Promise<HttpModel<boolean>>
}

export const StoresContract = (storesRepository: StoresRepository): IStores => ({
  getRestaurantData: async (
    merchantTargetId: number,
  ): Promise<HttpModel<RestaurantModel>> =>
    await storesRepository.GetRestaurantData(merchantTargetId),
  getRestaurantFoodTypes: async (): Promise<HttpModel<FoodTypeModel[]>> =>
    await storesRepository.GetRestaurantFoodTypes(),
  saveRestaurantData: async (data: StoreForm): Promise<HttpModel<boolean>> =>
    await storesRepository.SaveRestaurantData(data),
  getStoreContactsData: async (
    merchantTargetId: number,
  ): Promise<HttpModel<ContactModel[]>> =>
    await storesRepository.GetStoreContactsData(merchantTargetId),
  orderStoreStickers: async (data: StoreStickersForm): Promise<HttpModel<boolean>> =>
    await storesRepository.OrderStoreStickers(data),
  getKindergartenData: async (
    merchantTargetId: number,
  ): Promise<HttpModel<RestaurantModel>> =>
    await storesRepository.GetKindergartenData(merchantTargetId),
  saveKindergartenData: async (data: StoreForm): Promise<HttpModel<boolean>> =>
    await storesRepository.SaveKindergartenData(data),
})
